module.exports = __webpack_public_path__ + "static/media/20170806_44day_2124AT.6b358abb.jpg";